import React, { useEffect } from 'react';
import { Row, Col, CardBody } from 'reactstrap';
import { find, snakeCase } from 'lodash';
import { CardTitle, Field, useFetch } from '@cordata/buffet';
import { useFormikContext } from 'formik';

const methods = [
  'Phone',
  'Face-to-face',
  'Email',
  'Social media',
  'Mailing',
  'SMS',
].map(label => ({
  label,
  value: snakeCase(label),
}));

const OtherInteraction = () => {
  const {
    values,
    setFieldValue,
  } = useFormikContext();
  const [interactionStatus, interactions] = useFetch('data/reference/reference-medical-event-interaction', { initialValue: [], instance: 'p' });

  useEffect(() => {
    if (values.detailObject) {
      setFieldValue('name', values.detailObject.name);
      setFieldValue('method', values.detailObject.method && find(methods, r => r.value === values.detailObject.method).value);
    }
  }, [values.detailObject]);

  useEffect(() => {
    if (values.detailObject.type && interactions && interactions.length) {
      setFieldValue('type', values.detailObject.type
        ? find(interactions, r =>
          r.attributes.medicalEventInteractionName ===
            values.detailObject.type).attributes.medicalEventInteractionName
        : undefined);
    }
  }, [values.detailObject.type, interactions]);

  return (
    <>
      <hr />

      <CardBody>
        <CardTitle>Other Interaction Details</CardTitle>

        <Row form>
          <Col sm>
            <Field
              label="Who was the interaction with?"
              name="type"
              type="radio-group"
              options={interactions && interactions.length ? interactions.map(i => ({
                value: i.attributes.medicalEventInteractionName,
                label: i.attributes.medicalEventInteractionLabel,
              })) : []}
              required
              inline
              loading={interactionStatus === 'loading'}
            />
          </Col>

          <Col sm>
            <Field
              name="name"
            />
          </Col>

          <Col sm>
            <Field
              label="What channel did you use to make contact?"
              name="method"
              type="radio-group"
              options={methods}
              required
              inline
            />
          </Col>
        </Row>
      </CardBody>
    </>
  );
};

export default OtherInteraction;
